import { Link } from 'react-router';
import { AutoTask } from '../../../../shared/types/autoTask.ts';
import { formatDuration } from '../../../utils/fieldFormats.ts';
import { TaskRow } from './autoTaskRow.ts';


export function AutoTaskTableRow({ row }: { row: TaskRow }) {
    return (
        <tr className={row.highlightClass} style={{ margin: '8px 8px' }}>
            <EquipmentName row={row} />
            <ProductName task={row.task} />
            <TimeRemaining timeRemaining={row.timeRemaining} />
            <td className='tasks--large-text'>{row.notes}</td>
        </tr>
    );
}

function EquipmentName({ row }: { row: TaskRow }) {
    const { task, coordinates, name } = row;

    return (
        <td className='textAlignLeft'>
            <Link className='link-button--non-intrusive' to={`/machine-log#equipment=${task.equipment}`}>
                <span style={{ display: 'inline' }}>
                    <span className='tasks--large-text'>{coordinates}</span>
                    &nbsp;
                    {name}
                </span>
            </Link>
        </td>
    );
}

function ProductName({ task }: { task: AutoTask }) {
    return (
        <td className='textAlignLeft' title={task.product ?? undefined}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <span>{task.partDisplayName}</span>
                {task.produceAtNight && <img className='produce-at-night produce-at-night--tasks' src='/crescent-moon.png' />}
            </div>
        </td>
    );
}

function TimeRemaining({ timeRemaining }: { timeRemaining: number }) {
    const color = timeRemaining < 0 ? 'red' : '';

    return (
        <td className='tasks--large-text' style={{ color }}>
            {formatDuration(timeRemaining, true, false)}
        </td>
    );
}
